import React from 'react';
import SkylineStyles from './skyline/SkylineStyles';
import SkylineStars from './skyline/SkylineStars';
import SkylineClouds from './skyline/SkylineClouds';
import SkylineBuildings from './skyline/SkylineBuildings';
import SkylineWindows from './skyline/SkylineWindows';
import SkylineGroundTram from './skyline/SkylineGroundTram';

/**
 * CitySkyline — hand-drawn-style city silhouette across the footer.
 * Animation: left-to-right horizon reveal (clip-path), drifting clouds,
 * tram on rails, twinkling stars and blinking windows. Sub-layers live
 * under /components/skyline/.
 */
const CitySkyline = ({ stroke = '#1a2030', accent = '#8a94a6', accentAlt = '#f97316' }) => (
  <div className="absolute left-0 right-0 bottom-0 h-[280px] pointer-events-none overflow-hidden" data-testid="footer-city-skyline">
    <SkylineStyles />

    <svg
      className="absolute inset-0 w-full h-full"
      viewBox="0 0 1600 280"
      preserveAspectRatio="xMidYMax slice"
      xmlns="http://www.w3.org/2000/svg"
      style={{ overflow: 'visible' }}
    >
      <defs>
        <linearGradient id="cs-sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={accent} stopOpacity="0" />
          <stop offset="60%" stopColor={stroke} stopOpacity="0.05" />
          <stop offset="100%" stopColor={stroke} stopOpacity="0.18" />
        </linearGradient>
        <filter id="cs-rough" x="0%" y="0%" width="100%" height="100%">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" seed="3" />
          <feDisplacementMap in="SourceGraphic" scale="0.6" />
        </filter>
      </defs>

      {/* sky wash */}
      <rect x="0" y="0" width="1600" height="280" fill="url(#cs-sky)" />

      <SkylineStars accent={accent} />
      <SkylineClouds stroke={stroke} />

      <g className="cs-skyline">
        <SkylineBuildings stroke={stroke} accent={accent} accentAlt={accentAlt} />
        <SkylineWindows accentAlt={accentAlt} />
      </g>

      <SkylineGroundTram stroke={stroke} />
    </svg>
  </div>
);

export default CitySkyline;
